$(document).ready(function(){
	init(); 
});

function init() {
	// Helper Functions
	helperFunctions();

	//Lazyload Images
	lazyLoad();

	// Animations
	animations();
  
    //Footer
    footer();

    //Booking Widget
	bookingWidget();

	//Popups
	popups();

	// Selectric
	selectricInits();

	// Sliders
	sliderInits();

	// Lightboxes
	lightboxInits();

	// Maps
	googleMaps();

	// Inquiry Forms
	inquiryForms();

	// Gallery
	gallery();	

	// Signup Form
	signupForm();

	// Team Carousel
	teamCarousel();
}